var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertSettlement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16811b",
    d: "M10 1.667c.458 0 .875.242 1.108.642l7.225 12.508c.234.408.225.9-.025 1.3-.25.4-.683.641-1.15.641H2.842c-.467 0-.9-.242-1.15-.641-.25-.4-.259-.892-.025-1.3L8.892 2.309c.233-.4.65-.642 1.108-.642Zm0 5.833a.833.833 0 0 0-.833.833v3.334a.833.833 0 1 0 1.666 0V8.333A.833.833 0 0 0 10 7.5Zm0 7.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSettlement);
export default __webpack_public_path__ + "static/media/alert-settlement.b7a7422b50820b9408ef26fa9a3abedb.svg";
export { ForwardRef as ReactComponent };